import { useEffect } from 'react'
import { useRouter } from 'next/router'

/**
 * Embed prismic preview script only during preview mode.
 */
export const usePrismicPreviewScript = (): void => {
  const router = useRouter()

  useEffect(() => {
    if (router.isPreview) {
      const s = document.createElement('script')
      s.src = 'https://static.cdn.prismic.io/prismic.js?new=true&repo=flowcode-ui'
      s.className = 'optanon-category-C0003'
      s.type = 'text/javascript'
      s.defer = true

      document.body.appendChild(s)

      return () => {
        document.body.removeChild(s)
      }
    }
  }, [router])
}
